import { Component } from '@angular/core';

@Component({
  selector: 'app-smart-assistant-feed-page',
  standalone: false,
  templateUrl: './smart-assistant-feed-page.component.html',
  styleUrl: './smart-assistant-feed-page.component.scss',
})
export class SmartAssistantFeedPageComponent {}
